import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Button } from '../helpers/Button';
import DropDown, { DropDownElement } from '../helpers/DropDown';
import config from '../../config';
import { getUserRole } from '../../utils/checkPermissions';

/**
 * Home page actions shown in the app header: the web scraper extension and the stats reports menu.
 *
 * @param {object} props Props.
 */
const MainHeader = props => {
  const {
    userRole,
    onCCVisitsReport,
    onOffersAndBetterClick,
    onLeadsAndBetterClick,
    onOutreachReport,
    onCeoOutreachReport,
    onRetainerReportClick,
    onActivityReportClick,
    onConflictReportClick,
    onRetainerHealthReportClick,
    onScraperExtensionClick,
  } = props;
  let statusButton = null;
  let scraperExtensionButton = null;

  const role = getUserRole(userRole);

  if ([config.FINANCE_ADMIN, config.ADMINISTRATOR].includes(role)) {
    statusButton = (
      <div className="btn-group">
        <DropDown
          buttonContent={
            <span>
              <i className="fa fa-cog" />
              Stats
            </span>
          }
          className="btn-default btn-xs"
          id="main-stats-dropdown"
        >
          <DropDownElement onClick={onCCVisitsReport} type="link">
            Download CC/Visits Report
          </DropDownElement>
          <DropDownElement onClick={onOffersAndBetterClick} type="link">
            Download Offers &amp; Better Report
          </DropDownElement>
          <DropDownElement onClick={onLeadsAndBetterClick} type="link">
            Download Leads &amp; Better Report
          </DropDownElement>
          <DropDownElement onClick={onOutreachReport} type="link">
            Download Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onCeoOutreachReport} type="link">
            Download CEO Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onActivityReportClick} type="link">
            Download Activity Report
          </DropDownElement>
          <DropDownElement onClick={onConflictReportClick} type="link">
            Download Conflict Report
          </DropDownElement>
          <DropDownElement onClick={onRetainerReportClick} type="link">
            Download Retainer Report
          </DropDownElement>
          <DropDownElement onClick={onRetainerHealthReportClick} type="link">
            Retainer Health
          </DropDownElement>
          <DropDownElement target="_blank" to="/dashboard" type="link">
            Harvey &amp; Co. Dashboard
          </DropDownElement>
          <DropDownElement target="_blank" to="/director-dashboard" type="link">
            Statistics Dashboard
          </DropDownElement>
        </DropDown>
      </div>
    );
  }

  if ([config.DIRECTOR].includes(role)) {
    statusButton = (
      <div className="btn-group">
        <DropDown
          buttonContent={
            <span>
              <i className="fa fa-cog" />
              Stats
            </span>
          }
          className="btn-default btn-xs"
          id="main-stats-dropdown"
        >
          <DropDownElement onClick={onCCVisitsReport} type="link">
            Download CC/Visits Report
          </DropDownElement>
          <DropDownElement onClick={onOffersAndBetterClick} type="link">
            Download Offers &amp; Better Report
          </DropDownElement>
          <DropDownElement onClick={onLeadsAndBetterClick} type="link">
            Download Leads &amp; Better Report
          </DropDownElement>
          <DropDownElement onClick={onOutreachReport} type="link">
            Download Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onCeoOutreachReport} type="link">
            Download CEO Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onActivityReportClick} type="link">
            Download Activity Report
          </DropDownElement>
          <DropDownElement onClick={onConflictReportClick} type="link">
            Download Conflict Report
          </DropDownElement>
          <DropDownElement onClick={onRetainerHealthReportClick} type="link">
            Retainer Health
          </DropDownElement>
          <DropDownElement target="_blank" to="/dashboard" type="link">
            Harvey &amp; Co. Dashboard
          </DropDownElement>
          <DropDownElement target="_blank" to="/director-dashboard" type="link">
            Statistics Dashboard
          </DropDownElement>
        </DropDown>
      </div>
    );
  }

  if ([config.ANALYST_ASSOCIATE].includes(role)) {
    statusButton = (
      <div className="btn-group">
        <DropDown
          buttonContent={
            <span>
              <i className="fa fa-cog" />
              Stats
            </span>
          }
          className="btn-default btn-xs"
          id="main-stats-dropdown"
        >
          <DropDownElement onClick={onOutreachReport} type="link">
            Download Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onCeoOutreachReport} type="link">
            Download CEO Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onActivityReportClick} type="link">
            Download Activity Report
          </DropDownElement>
          <DropDownElement onClick={onRetainerHealthReportClick} type="link">
            Retainer Health
          </DropDownElement>
          <DropDownElement target="_blank" to="/dashboard" type="link">
            Harvey &amp; Co. Dashboard
          </DropDownElement>
          <DropDownElement noreferrer="true" target="_blank" to="/director-dashboard" type="link">
            View Statistics Dashboard
          </DropDownElement>
        </DropDown>
      </div>
    );
  }

  if ([config.JUNIOR_ANALYST].includes(role)) {
    statusButton = (
      <div className="btn-group">
        <DropDown
          buttonContent={
            <span>
              <i className="fa fa-cog" />
              Stats
            </span>
          }
          className="btn-default btn-xs"
          id="main-stats-dropdown"
        >
          <DropDownElement onClick={onCCVisitsReport} type="link">
            Download CC/Visits Report
          </DropDownElement>
          <DropDownElement onClick={onLeadsAndBetterClick} type="link">
            Download Leads &amp; Better Report
          </DropDownElement>
          <DropDownElement onClick={onOutreachReport} type="link">
            Download Outreach Report
          </DropDownElement>
          <DropDownElement onClick={onActivityReportClick} type="link">
            Download Activity Report
          </DropDownElement>
          <DropDownElement noreferrer="true" target="_blank" to="/director-dashboard" type="link">
            View Statistics Dashboard
          </DropDownElement>
        </DropDown>
      </div>
    );
  }

  if (!statusButton && role !== config.RESEARCHER) {
    statusButton = (
      <div className="btn-group">
        <DropDown
          buttonContent={
            <span>
              <i className="fa fa-cog" />
              Stats
            </span>
          }
          className="btn-default btn-xs"
          id="main-stats-dropdown"
        >
          <DropDownElement noreferrer="true" target="_blank" to="/director-dashboard" type="link">
            View Statistics Dashboard
          </DropDownElement>
        </DropDown>
      </div>
    );
  }

  if (role !== config.RESEARCHER) {
    scraperExtensionButton = (
      <Button icon="puzzle-piece" onClick={onScraperExtensionClick}>
        Web Scraper Extension
      </Button>
    );
  }

  return (
    <>
      {scraperExtensionButton}
      {statusButton}
    </>
  );
};

MainHeader.propTypes = {
  /**
   * On activity report click event handler.
   */
  onActivityReportClick: PropTypes.func.isRequired,
  /**
   * On CC visits report click event handler.
   */
  onCCVisitsReport: PropTypes.func.isRequired,
  /**
   * On CEO outreach report click event handler.
   */
  onCeoOutreachReport: PropTypes.func.isRequired,
  /**
   * On conflict report click event handler.
   */
  onConflictReportClick: PropTypes.func.isRequired,
  /**
   * On leads & better report click event handler.
   */
  onLeadsAndBetterClick: PropTypes.func.isRequired,
  /**
   * On offers & better click event handler.
   */
  onOffersAndBetterClick: PropTypes.func.isRequired,
  /**
   * On outreach report click event handler.
   */
  onOutreachReport: PropTypes.func.isRequired,
  /**
   * On web scraper extension click event handler.
   */
  onScraperExtensionClick: PropTypes.func.isRequired,
  /**
   * User role.
   */
  userRole: PropTypes.instanceOf(Map).isRequired,
};

export default memo(MainHeader);
